import { Platform, StyleSheet } from 'react-native';
import { MediaQueryStyleSheet } from "react-native-responsive";
import { MQ_TABLET } from '../../../constants';
import { PALETTE } from '../../../constants';

export default MediaQueryStyleSheet.create({
  textStyle:{
    color:'#000',
    flex: 0.85,
    marginTop:-5,
  },
  touchableOpacityTextStyle:{
    color:PALETTE.primaryActive,
    marginLeft:10,
    marginTop:-5
  },
}, {
  [MQ_TABLET]:{
    textStyle:{
      flex: 0.942,
    },
    touchableOpacityStyle:{
      flex: 0.058,
    }
  }
});
